import { apiClient } from "lib/apiClient";

export enum PrimaryPaymentTypeEnum {
  RENTAL = "Rental",
  BUY_IN = "Buy-in",
}

export enum ProfitTypeEnum {
  FOR_PROFIT = "For Profit",
  NOT_FOR_PROFIT = "Not For Profit",
}

export interface IPortfolioDashboardKpi {
  propertyCount: number;
  unitCount: number;
  avgCompAgeDays: number;
  avgOccupancyPercent: number;
  avgRentByCareType: Record<string, number>;
}

export interface IPortfolioDashboardMetric {
  subjectValue: number;
  compAverage: number;
  delta: number;
}

export interface IPortfolioDashboardMetrics {
  pricePerSf: IPortfolioDashboardMetric | null;
  occupancy: IPortfolioDashboardMetric | null;
  units: IPortfolioDashboardMetric | null;
  yearOpened: IPortfolioDashboardMetric | null;
  googleRating: IPortfolioDashboardMetric | null;
}

export interface IPortfolioDashboardProperty {
  id: string;
  name: string;
  latitude: number | null;
  longitude: number | null;
  photo: string;
  primaryPaymentType: PrimaryPaymentTypeEnum;
  profitType: ProfitTypeEnum;
  operator: string;
  compDate: string;
  metrics: IPortfolioDashboardMetrics;
}

export interface IPortfolioDashboardGroup {
  name: string;
  subjectCount: number;
  metrics: IPortfolioDashboardMetrics;
}

export interface IPortfolioDashboardGroups {
  deal: IPortfolioDashboardGroup[];
  state: IPortfolioDashboardGroup[];
  region: IPortfolioDashboardGroup[];
  marketType: IPortfolioDashboardGroup[];
}

export interface IPortfolioDashboard {
  kpi: IPortfolioDashboardKpi;
  properties: IPortfolioDashboardProperty[];
  groups: IPortfolioDashboardGroups;
}

export const getPortfolioDashboard = async (): Promise<IPortfolioDashboard> => {
  const response = await apiClient.get("/portfolio/dashboard");

  return response.data;
};
